import React from 'react';
import { Place } from '@/types';
import { useOverTimeData } from '@/hooks/useOverTimeData';
import { IntroductoryTextSection } from './IntroductoryTextSection';
import { OverTimeChartsSection } from './OverTimeChartsSection';
import { LoadingSpinner } from '@/components/shared/LoadingSpinner';

interface OverTimeViewProps {
  selectedPlace: Place | null;
}

export const OverTimeView: React.FC<OverTimeViewProps> = ({ selectedPlace }) => {
  console.log('🟦 OverTimeView - selectedPlace:', selectedPlace);
  
  const { data, loading, error } = useOverTimeData(selectedPlace);
  
  console.log('🟦 OverTimeView - hook result:', { data, loading, error, dataLength: data?.length });

  const introductionText = "Track how your jurisdiction has changed over time with a 5-year view of key housing and permitting metrics from 2019–2023. This page highlights trends in growth, affordability, and development to support long-term planning and progress tracking.";

  if (loading) {
    console.log('🟦 OverTimeView - showing loading state');
    return <LoadingSpinner />;
  }

  if (error) {
    console.log('🟦 OverTimeView - showing error state:', error);
    return <div className="text-red-500 text-center p-4">Error: {error}</div>;
  }

  console.log('🟦 OverTimeView - rendering charts with data:', data);
  
  return (
    <div>
      <IntroductoryTextSection
        title="Understanding the Over Time View"
        description={introductionText}
      />
      {data && <OverTimeChartsSection data={data} />}
    </div>
  );
}; 